<nova-rich-tooltip [displayTemplate]="vaccinationTooltipTemplate" width="250">
    <span *ngFor="let item of data; let last = last">
        <strong>{{ item.vaccinationTypeName }}</strong>:
        {{ item.vaccinationStatusName }}{{ !last ? ', ' : ''}}
    </span>
</nova-rich-tooltip>

<ng-template #vaccinationTooltipTemplate>
    <div *ngFor="let item of data" class="vaccine-item">
        <strong>{{ item.vaccinationTypeDescription }}</strong>:
        <br>
        {{ item.vaccinationStatusDescription }}
    </div>
</ng-template>
